import { Injectable, Injector } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UserDao } from '@app/dao/user/user.dao';
import { FundsOrigin } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';
import { PledgeProductRead } from '../../definition/interface/Pledge';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  userId;
  constructor(
    protected formConstructor: PrFormConstructor,
    protected injector: Injector,
  ) {
    super(formConstructor);
    injector
      .get(UserDao)
      .authOnce$()
      .subscribe(user => {
        this.userId = user.id;
      });
  }

  generateForm(entity: PledgeProductRead & { parameters: any }) {
    let options: AbstractControlOptions = {};

    const { parameters = {} } = entity;

    const isSwisslife =
      parameters &&
      parameters.partnerFlux &&
      parameters.partnerFlux === 'SWISSLIFE';

    const parametersGroup = this.formBuilder.group({
      fundsOriginList: this.formBuilder.array([this.formGroup(isSwisslife)]),
    });

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: parametersGroup,
    };

    const formBuilderGroup = this.formBuilder.group(formConfig, options);
    entity?.parameters?.fundsOriginList?.length > 0 &&
      parametersGroup.setControl(
        'fundsOriginList',
        this.populate(entity?.parameters, isSwisslife),
      );

    return formBuilderGroup;
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }
  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  populate(data: FundsOrigin, isSwisslife: boolean) {
    let formArray = this.formBuilder.array([this.formGroup(isSwisslife)]);
    if (data) {
      formArray.clear();
      data.fundsOriginList.forEach((item, index) => {
        formArray.push(
          this.formBuilder.group({
            date: [item?.date || new Date(), Validators.required],
            fundOrigin: [item.fundOrigin, Validators.required],
            distribution: [
              item?.repartitionType === 'PERCENTAGE'
                ? +item.distribution * 100
                : +item.distribution,
              Validators.required,
            ],
            fundOriginOtherDetail: [item?.fundOriginOtherDetail],
            repartitionType: [item?.repartitionType || 'PERCENTAGE'],
            description: [
              item?.description,
              isSwisslife ? Validators.required : Validators.nullValidator,
            ],
            fundEmmiter: [
              item?.fundEmmiter,
              isSwisslife ? Validators.required : Validators.nullValidator,
            ],
            financialInstitution: [
              item?.financialInstitution,
              isSwisslife ? Validators.required : Validators.nullValidator,
            ],
            source: [item?.source || 'FR', Validators.required],
          }),
        );
      });
    }
    return formArray;
  }
  formGroup(isSwisslife: boolean): UntypedFormGroup {
    return this.formBuilder.group({
      date: [new Date(), Validators.required],
      fundOrigin: ['SAVING', Validators.required],
      distribution: [100, Validators.required],
      repartitionType: ['PERCENTAGE', Validators.nullValidator],
      fundOriginOtherDetail: ['', Validators.nullValidator],
      description: [
        '',
        isSwisslife ? Validators.required : Validators.nullValidator,
      ],
      fundEmmiter: [
        '',
        isSwisslife ? Validators.required : Validators.nullValidator,
      ],
      financialInstitution: [
        '',
        isSwisslife ? Validators.required : Validators.nullValidator,
      ],
      source: ['FR', Validators.required],
    });
  }
  extract() {
    const formValue = _.cloneDeep(this.form?.value?.products);

    formValue?.forEach(item => {
      item?.parameters?.fundsOriginList.forEach(fund => {
        fund.distribution =
          fund.repartitionType === 'PERCENTAGE'
            ? fund.distribution / 100
            : fund.distribution;
      });
    });
    return formValue;
  }
}
